import { call, put } from 'redux-saga/effects';
import ActionTypes from '@ziynx/action-types';
import type { StatementDataType } from '@ziynx/flow-types/statements';

type GetStatementResponse = Array<StatementDataType>;

type GetStatementAction = {
  id: string,
  type: string,
};

export function* getAll(action: GetStatementAction): Generator<any, void, empty> {
  const actionId = action?.id || 'me';

  try {
    const response: GetStatementResponse = yield call(() => APIService.apiRequest('GET_STATEMENTS', 'GET', {
      routeParams: {
        id: action?.id,
      },
    }));

    yield put({
      type: ActionTypes.statements.getAll.SUCCESS,
      id: actionId,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.statements.getAll.ERROR,
      id: actionId,
      error,
    });
  }
}

export function* postQuestion(action): Generator<any, void, empty> {
  const actionId = action?._id;
  try {
    const response = yield call(() => APIService.apiRequest('POST_QUESTION', 'POST', {
      body: action?.body ?? {},
    }));
    yield put({
      type: ActionTypes.statementItem.postQuestion.SUCCESS,
      id: response?._id,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.statementItem.postQuestion.ERROR,
      id: actionId,
      error,
    });
  }
}

export function* getQuestion(action): Generator<any, void, empty> {
  try {
    const response = yield call(() => APIService.apiRequest('GET_QUESTION', 'GET', {
      routeParams: {
        id: action?.id,
      },
    }));
    yield put({
      type: ActionTypes.statementItem.getQuestion.SUCCESS,
      id: action?.id,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.statementItem.getQuestion.ERROR,
      error,
    });
  }
}

export function* patchQuestion(action): Generator<any, void, empty> {
  const actionId = action?.id ?? 'me';
  try {
    const response = yield call(() => APIService.apiRequest('PATCH_QUESTION', 'PATCH', {
      routeParams: {
        id: actionId,
      },
      body: action?.body ?? [],
    }));
    yield put({
      type: ActionTypes.statementItem.patchQuestion.SUCCESS,
      id: actionId,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.statementItem.patchQuestion.ERROR,
      id: actionId,
      error,
    });
  }
}

export function* removeQuestion(action): Generator<any, void, empty> {
  const actionId = action?.id ?? 'me';
  try {
    const response = yield call(() => APIService.apiRequest('REMOVE_QUESTION', 'DELETE', {
      routeParams: {
        id: actionId,
      },
    }));
    yield put({
      type: ActionTypes.statements.removeQuestion.SUCCESS,
      id: actionId,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.statements.removeQuestion.ERROR,
      id: actionId,
      error,
    });
  }
}

export function* getQuestionResponses(action): Generator<any, void, empty> {
  const actionId = action?.id;
  try {
    const response = yield call(() => APIService.apiRequest('GET_QUESTION_RESPONSES', 'GET', {
      routeParams: {
        id: actionId,
      },
      query: action?.query || {},
    }));

    const isPaginating = response?.page > 0;

    yield put({
      type: ActionTypes.statementItem.getQuestionResponses.SUCCESS,
      id: actionId,
      response,
      isPaginating,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.statementItem.getQuestionResponses.ERROR,
      id: actionId,
      error,
    });
  }
}
